import { render, staticRenderFns } from "./BaseCommission.vue?vue&type=template&id=bcb23fa2&scoped=true"
import script from "./BaseCommission.vue?vue&type=script&lang=js"
export * from "./BaseCommission.vue?vue&type=script&lang=js"
import style0 from "./BaseCommission.vue?vue&type=style&index=0&id=bcb23fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb23fa2",
  null
  
)

export default component.exports